import React from "react";
import { DPDialog } from "Components/DP";
import CreateAdminForm from "./CreateAdminForm/CreateAdminForm";

type Props = {
  page: number;
  isOpen: boolean;
  onClose: () => void;
};

const CreateAdminModal = ({ page, isOpen, onClose }: Props) => {
  return (
    <DPDialog
      open={isOpen}
      onClose={onClose}
    >
      <CreateAdminForm handleClose={onClose} page={page}/>
    </DPDialog>
  );
};

export default CreateAdminModal;
